export default "__VITE_ASSET__DigUxmfj__"